<script setup lang="ts">
import {computed} from "vue";
import {InputNumber, Label} from "@/Components/Library";

const props = defineProps<{
    question: {[key: string]: any; options: string[]};
    disabled?: boolean;
}>();

const model = defineModel();
const sum = computed(() => {
    return Object.values(model.value).reduce((a, b) => +a + +b, 0);
});
</script>
<template>
    <div>
        <h3 class="mb--1">Allocate 100 points between the options</h3>
        <div class="flex flex-col divide-y dark:divide-stone-700">
            <template v-for="option in question.options">
                <div class="flex items-center gap-4 py-4" :class="[{'flex-col': option.image?.url}]">
                    <Label :for="option.id" class="flex grow flex-col">
                        <img
                            v-if="option.image?.url"
                            class="mb-1 h-auto w-full rounded-md"
                            :src="option.image.url"
                            :alt="option.value"
                        />
                        <p class="text-base">{{ option.value }}</p>
                    </Label>
                    <InputNumber
                        :input-id="option.id"
                        showButtons
                        buttonLayout="horizontal"
                        :min="0"
                        :max="100"
                        v-model="model[option.id]"
                        :input-class="`${option.image?.url ? 'w-full' : 'w-16'}`"
                        :disabled
                    />
                </div>
            </template>
        </div>
        <div class="text-right text-lg font-bold" :class="{'text-red-600': sum > 100, 'text-green-600': sum === 100}">
            Total {{ sum }}/100
        </div>
    </div>
</template>
<style scoped></style>
